import chroma from 'chroma-js';

// Formation band styling shared by the Gun Barrel + 2D Profile: translucent
// fill (heavier for shale) over a darkened boundary stroke.
const BAND_ALPHA = 0.32;
const SHALE_BAND_ALPHA = 0.55;
const STROKE_DARKEN = 0.78;

const toAlphaHex = (a: number): string =>
  Math.round(a * 255)
    .toString(16)
    .padStart(2, '0');

// Translucent band fill — shale bands get a heavier alpha.
export function formationBandFill(hex: string, name: string): string {
  const alpha = /shale/i.test(name) ? SHALE_BAND_ALPHA : BAND_ALPHA;
  return `${hex}${toAlphaHex(alpha)}`;
}

// Darkened (×0.78 per channel) variant of the fill color for the boundary stroke.
export function formationBandStroke(hex: string): string {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return hex;
  const [r, g, b] = chroma(`#${match[1]}`).rgb();
  return chroma
    .rgb(r * STROKE_DARKEN, g * STROKE_DARKEN, b * STROKE_DARKEN)
    .hex();
}
